<template>
  <div class="dashboard-module page">
    <DashboardTopNavbar :app-name="appName" @logout="logout" />
    <NavigationDrawer :items="navigationItems" />
    <v-main class="mb-5" :class="breakpointMargin">
      <router-view />
    </v-main>
  </div>
</template>
<script>
import config from "@/config.js";
import DashboardTopNavbar from "@/modules/DashboardModule/components/DashboardTopNavbar";
import NavigationDrawer from "@/modules/DashboardModule/components/NavigationDrawer";
import Auth from "@/packages/auth";
import documentTypeCodes from "@/packages/dataFiles/documentTypeCodes.json";
import { GET_LOGGED_IN_USER } from "@/modules/AuthModule/store/actionTypes.js";
import { SNACKBAR } from "@/store/actionTypes";
import { STORE_DOCUMENT_TYPE_CODES } from "@/modules/DashboardModule/modules/ImportExportModule/store/actionTypes";
import { GET_ESANCHIT_SUPPORTING_DOC } from "@/modules/DashboardModule/modules/ImportExportModule/store/actionTypes";
import { GET_EXPORTERS } from "@/modules/DashboardModule/store/actionTypes";
import { GET_ACCOUNT_DETAILS } from "@/modules/DashboardModule/store/actionTypes";
import commonMethodsMixin from "@/modules/commonMethodsMixin";
export default {
  name: "DashboardModule",
  components: {
    DashboardTopNavbar,
    NavigationDrawer
  },
  created() {
    this.getUser();
    this.getAccountDetails();
    this.$store.dispatch(SNACKBAR, {
      color: "success",
      text: `Welcome, ` + this.$store.getters.user.name,
      timeout: 3000
    });
  },
  mounted() {
    this.storeDocumentTypeCodes();
    this.getSupportingDocs();
    this.getExporters();
  },
  data() {
    return {
      //
    };
  },
  computed: {
    appName() {
      return config.appTitle();
    },
    breakpointMargin() {
      switch (this.breakpoint) {
        case "xs":
          return "mt-4 mx-4";
        case "sm":
          return "mt-7 mx-7";
        case "md":
          return "mt-9 mx-9";
        case "lg":
          return "mt-11 mx-11";
        case "xl":
          return "mt-11 mx-11";
        default:
          return "w-75";
      }
    },
    exportJobId() {
      return (this.$route && this.$route.params && this.$route.params.exportJobId) || "new";
    },
    navigationItems() {
      return [
        {
          title: "Dashboard",
          icon: "far fa-newspaper",
          route: { name: "dashboard.home" },
          active: false,
          children: [
            // {
            //   title: "Import",
            //   icon: "fas fa-cloud-download-alt",
            //   imageUrl: "/img/import_normal.svg",
            //   type: "image",
            //   route: { name: "dashboard.import" }
            // },
            {
              title: "Export Jobs",
              icon: "fas fa-cloud-upload-alt",
              //   type: "image",
              //   imageUrl: "/img/export_normal.svg",
              route: { name: "dashboard.export" },
              children: [
                {
                  title: "SB Main",
                  icon: "fas fa-tasks",
                  route: { name: "dashboard.export.sbMain", params: { exportJobId: this.exportJobId } }
                },
                {
                  title: "Exporter",
                  icon: "fas fa-walking",
                  route: { name: "dashboard.export.exporter", params: { exportJobId: this.exportJobId } }
                },
                {
                  title: "Consignee",
                  icon: "fas fa-user-circle",
                  route: { name: "dashboard.export.consignee", params: { exportJobId: this.exportJobId } }
                },
                {
                  title: "Invoices & Products",
                  icon: "fas fa-receipt",
                  route: { name: "dashboard.export.invoice-products", params: { exportJobId: this.exportJobId } },
                  children: [
                    {
                      title: "Add Invoice",
                      icon: "fas fa-plus-square",
                      route: {
                        name: "dashboard.export.invoice-products.add-invoice",
                        params: { exportJobId: this.exportJobId }
                      }
                    }
                  ]
                },
                {
                  title: "Freight & Insurance",
                  icon: "fas fa-shield-alt",
                  route: { name: "dashboard.export.freight-insurance", params: { exportJobId: this.exportJobId } }
                },
                {
                  title: "Container",
                  icon: "fas fa-boxes",
                  route: { name: "dashboard.export.container", params: { exportJobId: this.exportJobId } }
                },
                {
                  title: "Shipment",
                  icon: "fas fa-truck-moving",
                  route: { name: "dashboard.export.shipment", params: { exportJobId: this.exportJobId } }
                },
                {
                  title: "Supporting Doc",
                  icon: "fa fa-file",
                  route: { name: "dashboard.export.supporting-doc", params: { exportJobId: this.exportJobId } }
                }
              ]
            }
          ]
        },
        { title: "Clients", icon: "fas fa-user-friends", route: { name: "dashboard.clients" } },
        { title: "Users", icon: "fas fa-user-circle", route: { name: "dashboard.users" } },
        // { title: "Reports", icon: "fas fa-copy", route: { name: "dashboard.reports" } },
        { title: "Settings", icon: "fas fa-cog", route: { name: "dashboard.settings" } },
        // { title: "Subscription", icon: "fa fa-file-powerpoint", route: { name: "dashboard.subscription" } },
        { title: "E-Sanchit", icon: "fa fa-paperclip", route: { name: "dashboard.eSanchit" } }
      ];
    }
  },
  mixins: [commonMethodsMixin],
  methods: {
    getExporters() {
      this.$store.dispatch(GET_EXPORTERS);
    },
    getAccountDetails() {
      this.$store.dispatch(GET_ACCOUNT_DETAILS);
    },
    logout() {
      Auth.logout();
      this.$router.push({ name: "auth.login" });
    },
    getUser() {
      this.$store.dispatch(GET_LOGGED_IN_USER).finally(() => (this.loading = false));
    },
    storeDocumentTypeCodes() {
      let documentTypeCodeData = {
        documentTypeCodes: documentTypeCodes.documentTypeCodes
      };
      this.$store.dispatch(STORE_DOCUMENT_TYPE_CODES, documentTypeCodeData);
      return;
    },
    getSupportingDocs() {
      const timePeriodId = this.$store.getters.globalTimePeriod;
      this.$store.dispatch(GET_ESANCHIT_SUPPORTING_DOC, timePeriodId);
    }
  }
};
</script>
